export default "__VITE_ASSET__DCfJIBBG__"